import script from "./ApplicationStatusCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./ApplicationStatusCard.vue?vue&type=script&lang=ts&setup=true"

import "./ApplicationStatusCard.vue?vue&type=style&index=0&id=20c7b9cc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20c7b9cc"]])

export default __exports__